<template>
  <div>
    <el-divider>Lugares de entrega </el-divider>
    <div
      v-for="(lugar, index) in modelValue"
      :key="index"
      class="lugar-row"
    >
      <el-row
        :gutter="16"
        align="middle"
        style="margin-bottom: 1rem"
      >
        <el-col :span="7">
          <el-form-item :prop="`${propPrefix}.${index}.Descripcion`">
            <custom-input
              v-model="lugar.Descripcion"
              label="Descripción"
              :settings="{ maxlength: 50 }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :prop="`${propPrefix}.${index}.Provincia`">
            <custom-input
              v-model="lugar.Provincia"
              label="Provincia"
              :settings="{ maxlength: 50 }"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item :prop="`${propPrefix}.${index}.DireccionDetallada`">
            <custom-input
              v-model="lugar.DireccionDetallada"
              label="Detalle de dirección"
              :settings="{ maxlength: 250 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        :gutter="16"
        align="middle"
        style="margin-bottom: 1rem"
      >
        <el-col :span="10">
          <el-form-item :prop="`${propPrefix}.${index}.ContactoEntrega`">
            <custom-input
              v-model="lugar.ContactoEntrega"
              label="Contacto de entrega"
              :settings="{ maxlength: 100 }"
            />
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item :prop="`${propPrefix}.${index}.TelefonoEntrega`">
            <custom-input
              v-model="lugar.TelefonoEntrega"
              label="Teléfono de entrega"
              :settings="{ maxlength: 30 }"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="3"
          class="text-center"
        >
          <el-button
            v-if="modelValue.length > 0"
            :icon="IconDelete"
            type="danger"
            circle
            @click="remove(index)"
          />
        </el-col>
      </el-row>
    </div>
    <el-button
      type="text"
      class="add-lugar-btn"
      @click="add"
    >
      <IconAdd /> Agregar lugar de entrega
    </el-button>
  </div>
</template>

<script setup>
import IconAdd from '~icons/mdi/add';
import IconDelete from '~icons/mdi/delete';
import CustomInput from '@/shared/components/custom_input.vue';
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  propPrefix: {
    type: String,
    default: 'LugaresEntrega',
  },
});
const emit = defineEmits(['update:modelValue']);

function add() {
  const updated = [
    ...props.modelValue,
    {
      Descripcion: '',
      Provincia: '',
      DireccionDetallada: '',
      ContactoEntrega: '',
      TelefonoEntrega: '',
    },
  ];
  emit('update:modelValue', updated);
}

function remove(idx) {
  const updated = props.modelValue.slice();
  updated.splice(idx, 1);
  emit('update:modelValue', updated);
}
</script>

<style scoped>
.add-lugar-btn {
  margin-top: 0.5rem;
  color: #409eff;
}
.lugar-row {
  padding: 0.5rem 0.75rem;
  border: 1px solid #b3b8c1;
  border-radius: 8px;
  margin-bottom: 0.75rem;
}
</style>
